<template>
  <div class="profile">
    <div class="frow centered">
      <div class="box">
        <div
          class="back"
          @click="$router.go(-1)"
        >
          <i class="fas fa-arrow-left fa-2x is-pulled-left" />
        </div>
        <h1 class="title">Profile</h1>
        <h2 class="subtitle is-6">{{ user.username }}</h2>
        <div class="frow column-start">
          <h2 class="subtitle">Change password</h2>
          <div class="frow gutters mb-20 width-100">
            <div class="col-sm-1-2">
              <div class="field">
                <label class="label" for="newPassword">New Password</label>
                <input
                    v-model="newPassword"
                    class="input"
                    id="newPassword"
                    name="newPassword"
                    type="password"
                >
              </div>
            </div>
            <div class="col-sm-1-2">
              <div class="field">
                <label class="label" for="newPasswordConfirm">Confirm Password</label>
                <input
                    v-model="newPasswordConfirm"
                    class="input"
                    id="newPasswordConfirm"
                    name="newPasswordConfirm"
                    type="password"
                >
              </div>
            </div>
          </div>
          <!-- :class="{'is-loading': saving}" -->
          <button
            v-if="passwordsMatch"
            class="button is-success mt-20"
            @click="changePassword"
          >
            Change Password
          </button>
        </div>
        <div v-if="user.role.type === 'administrator' || user.role.type === 'root'">
          <h1 class="title">Users</h1>
          <div class="card frow">
            <div class="col-md-1-2">
              <strong>Email</strong>
            </div>
            <div class="col-md-1-2">
              <strong>Role</strong>
            </div>
          </div>
          <div
            v-for="u in users"
            :key="u.id"
            class="card frow"
          >
            <div class="col-md-1-2">
              {{ u.email }}
            </div>
            <div class="col-md-1-2">
              {{ u.role.name }}
            </div>
          </div>
          <br />
          <button @click="showNewUserModal = true">
            Add New User
          </button>
        </div>
      </div>
    </div>
    <ShowNewUserModal
      v-if="showNewUserModal"
      @closeModal="closeModal"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ShowNewUserModal from '@/components/NewUserModal';

export default {
  name: 'profile',
  components: { ShowNewUserModal },
  data() {
    return {
      user: {},
      users: [],
      newPassword: null,
      newPasswordConfirm: null,
      showNewUserModal: false,
    };
  },
  computed: {
    ...mapState({
      jwt: state => state.profile.jwt,
    }),
    API() {
      return this.$API;
    },
    passwordsMatch() {
      return this.newPassword && this.newPassword === this.newPasswordConfirm;
    },
  },
  methods: {
    changePassword() {
      this.axios({
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${this.jwt}`,
        },
        url: `${this.$API}/users/${this.user.id}`,
        data: {
          email: this.user.email,
          username: this.user.username,
          password: this.newPassword,
        },
      }).then(() => {
        this.$store.commit('logout');
      });
    },
    closeModal() {
      this.showNewUserModal = false;
      this.getUsers();
    },
    getProfile() {
      this.axios({
        method: 'GET',
        headers: {
          Authorization: `Bearer ${this.jwt}`,
        },
        url: `${this.$API}/users/me`,
      }).then((res) => {
        this.user = res.data;
      });
    },
    getUsers() {
      this.axios({
        method: 'GET',
        headers: {
          Authorization: `Bearer ${this.jwt}`,
        },
        url: `${this.$API}/users`,
      }).then((res) => {
        this.users = res.data;
      });
    },
  },
  created() {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push('/login');
    } else {
      this.getProfile();
      this.getUsers();
    }
  },
};
</script>
<style lang="scss" scoped>
.profile {
  background-color: #fff;
  overflow: hidden;
  height: 100%;
  width: 100%;
}
.box {
  height: 800px;
  width: 800px;
}
.back {
  cursor: pointer;
}
</style>
